import React from 'react';

import { StoreAppAPI } from '../../core/src/storeapp-api-client';
import {withError} from '../../shared/components/error-boundary';
const storeAppAPI = new StoreAppAPI();

class ExternalSkuUpsell extends React.PureComponent {
    state = {
        upsell: {
            productsList: []
        }
    }

    componentDidMount() {
        this.fetchUpell();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.category !== this.props.category) {
            this.fetchUpell()
        }
    }

    fetchUpell = () => {
        if (this.props.category) {
            storeAppAPI.product.recommended(this.props.category).then(({data}) => {
                this.setState({
                    upsell: { productsList: data || [] }
                })
            });
        }
    }

    render() {
        const { upsell } = this.state;
        if(upsell && upsell.productsList.length > 0){
            return <div className={'ext-pdp-upsell'}>
                {this.props.children({ upsell: { upsell }, prdClass:'EXT' })}
            </div>
        }else{
            return null
        }
    }
}

export default withError(ExternalSkuUpsell);